export default "__VITE_ASSET__fc195771__"